module.exports = function getResource (label) {
    let resources = {
        editBasket: 'Edit basket',
        hideOrderSummary: 'Hide Order Summary',
        showOrderSummary: 'Show Order Summary',
        itemsInOrder: 'Items in order',
        itemInOrder: 'Item in order',
        viewBasket: 'View basket',
        qty: 'Qty',
        shippingRestrictions: 'Shipping Restrictions'
    };
    return resources[label];
};
